import { t } from 'i18next';
import { joinCampaign } from 'src/shared';
import { useRevealOnScroll } from 'src/shared';

type LpFinalCtaProps = {
  programId: string | undefined;
  isPublished: boolean | undefined;
};

export default function LpFinalCta({ programId, isPublished }: LpFinalCtaProps) {
  const ref = useRevealOnScroll<HTMLDivElement>();

  function handleJoin() {
    if (isPublished && programId) {
      joinCampaign(programId);
    }
  }

  return (
    <section className="final section-pad" id="join" aria-labelledby="lp-finalcta-title">
      <div ref={ref} className="wrap reveal">
        <span className="eyebrow" style={{ justifyContent: 'center' }}>
          <span className="dot" />{t('landingPage.v2.finalCta.eyebrow')}
        </span>
        <h2 className="display" id="lp-finalcta-title">
          {t('landingPage.v2.finalCta.title')}
        </h2>
        <button
          className="btn btn--primary"
          onClick={handleJoin}
          disabled={!isPublished}
        >
          {isPublished
            ? t('landingPage.v2.finalCta.cta')
            : t('landingPage.header.comingSoon')}
          {isPublished && <span className="arr">→</span>}
        </button>
        <p className="hint">{t('landingPage.v2.finalCta.hint')}</p>
      </div>
    </section>
  );
}
